<template>
	<div>
		<el-dialog :visible.sync="visible" title="恢复" width="540px" :before-close="beforeClose" :close-on-click-modal="false">
			<tip class="mb-24" type="warning" content="达人恢复后，达人运营将可以重新认领达人从【线索】状态开始跟进。"></tip>
			<div class="flex-row-align-center">
				<div class="font-h4-regular" style="width: 100px">
					<span class="yx-color-danger">*</span>
					<span class="yx-color-text-primary ml-2">恢复</span>
				</div>
				<div class="ml-12">
					<el-radio v-model="radio" label="1">恢复到团队公海</el-radio>
					<el-radio v-model="radio" label="2">恢复后指派给达人运营</el-radio>
				</div>
			</div>
			<div class="flex-row-align-center mt-24" v-if="radio === '2'">
				<div class="font-h4-regular" style="width: 100px">
					<span class="yx-color-danger">*</span>
					<span class="yx-color-text-primary ml-2">跟进达人运营</span>
				</div>
				<div class="ml-12 flex-1">
					<DrPartnerSelect ref="DrPartnerSelect" v-model="form.toUserId" style="width: 100%"></DrPartnerSelect>
				</div>
			</div>
			<div class="mt-24 mb-24 p-16 yx-background font-h4-regular radius-4">
				<div>
					<span class="yx-color-danger">*</span>
					<span class="yx-color-text-primary ml-2">恢复原因</span>
				</div>
				<div class="mt-8">
					<el-input
						v-model="form.unblockReason"
						:rows="3"
						type="textarea"
						maxlength="100"
						minlength="0"
						show-word-limit
						placeholder="请输入达人恢复原因"
					></el-input>
				</div>
			</div>
			<div slot="footer">
				<el-button @click="beforeClose">取 消</el-button>
				<el-button type="primary" @click="submit" :disabled="!isDisabled">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import DrPartnerSelect from '@/components/drPartnerSelect';
import { blacklistUnblock, batchBlacklistUnblock } from '@/api/talentCRM';
export default {
	components: {
		DrPartnerSelect,
	},
	props: {
		platformId: {
			type: [String, Number],
			default: +dataMap.PLATFORM_DY.value,
		},
	},
	computed: {
		isDisabled({ form, radio }) {
			if (radio === '1') {
				return !!form.unblockReason;
			} else {
				return !!form.toUserId && !!form.unblockReason;
			}
		},
	},
	data() {
		return {
			visible: false,
			form: {
				unblockReason: '',
				toUserId: '',
			},
			radio: '1',
			type: 'single',
			anchorInfo: '',
			many_partner: 0,
		};
	},
	methods: {
		show(type = 'single', val) {
			this.type = type;
			this.anchorInfo = val;
			this.visible = true;
		},
		beforeClose() {
			this.form = {
				unblockReason: '',
				toUserId: '',
			};
			this.radio = '1';
			this.anchorInfo = '';
			this.$refs?.DrPartnerSelect?.reset();
			this.visible = false;
		},
		async submit() {
			const { type, anchorInfo, platformId, form } = this;
			let api = {
				single: blacklistUnblock,
				batch: batchBlacklistUnblock,
			};
			let params = {
				single: {
					anchorId: anchorInfo.anchor_id,
					platformId,
					...form,
				},
				batch: {
					anchorIds: Array.isArray(anchorInfo) ? anchorInfo.map(item => item.anchor_id) : '',
					platformId,
					...form,
				},
			};
			await api[type](params[type]);
			this.beforeClose();
			this.$message.success('操作成功！');
			this.$emit('refresh');
		},
	},
};
</script>
